import { createScriptsRuntime } from '@eventbuilder-utils/scripts/runtime';
import { createScript } from '@eventbuilder-utils/scripts';
import { EBSession } from './session';

let loadedTenantScriptScopeId = null;

function createRegistrarToken() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `ebsr-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function getScopeUrl(type, id) {
    return `/assets/${type === 'tenant' ? 'tenants' : `${type}s`}/js/${id}.js`;
}

async function evaluateScopeSource(source, _scopeMeta, registrationContext) {
    const payload = typeof source === 'string' ? { code: source, registrarToken: null } : source;
    const blob = new Blob([payload.code], { type: 'application/javascript' });
    const objectUrl = URL.createObjectURL(blob);

    window.__EB_SCRIPTS_SCOPE_REGISTRARS__ ||= Object.create(null);

    try {
        if (payload.registrarToken) {
            window.__EB_SCRIPTS_SCOPE_REGISTRARS__[payload.registrarToken] = registrationContext;
        }
        await import(/* webpackIgnore: true */ objectUrl);
    } finally {
        if (payload.registrarToken) {
            delete window.__EB_SCRIPTS_SCOPE_REGISTRARS__[payload.registrarToken];
        }
        URL.revokeObjectURL(objectUrl);
    }
}

export const EBScripts = createScriptsRuntime({
    createScriptFactory: () => createScript(),
    loadScopeSource: async (scopeMeta, opts = {}) => {
        const registrarToken = createRegistrarToken();
        const url = `${getScopeUrl(scopeMeta.type, scopeMeta.id)}?ebsr=${encodeURIComponent(registrarToken)}`;
        const response = await EBSession.download(url); // await (opts.fetch ? opts.fetch(url) : fetch(url));

        if (!response.ok) {
            throw new Error(`[EBScripts] Failed to load scope scripts (${response.status}): ${url}`);
        }

        return { code: await response.text(), registrarToken };
    },
    evaluateScopeSource,
    createRegistrationContext: (_scopeMeta, registrar) => registrar,
    onLoadError: (error, scopeMeta) => {
        console.error(`[EBScripts] Failed to load scope ${scopeMeta.scopeKey}:`, error);
    }
});

if (typeof window !== 'undefined') {
    window.EBScripts = EBScripts;
}

export async function switchAdminTenantScripts(tenantId, fetchFn) {
    if (!tenantId) return;

    if (loadedTenantScriptScopeId && loadedTenantScriptScopeId !== tenantId) {
        EBScripts.unloadScope('tenant', loadedTenantScriptScopeId);
    }

    await EBScripts.loadScope('tenant', tenantId, {
        mode: 'always',
        fetch: fetchFn
    });

    loadedTenantScriptScopeId = tenantId;
}
